import { Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Editor, Toolbar } from 'ngx-editor';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { AutoSaveComponent } from '../../report-2500-8/auto-save/auto-save.component';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';

@Component({
  selector: 'app-accomplishment-additional',
  templateUrl: './accomplishment-additional.component.html',
  styleUrls: ['./accomplishment-additional.component.scss'],
  standalone: false
})

export class AccomplishmentAdditionalComponent extends AutoSaveComponent implements OnChanges, OnInit {
  //icons
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;

  reg = APP_CONSTANTS.URL_REGEX;

  report = input.required<any>();
  reportList = input.required<any>();
  currentUser = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  saveSubject = new Subject<any>();
  additional_reports: any[] = [];

  form = this.formBuilder.group({
    success_failure: ["", [Validators.maxLength(6000), Validators.required]],
    recommendations: ["", [Validators.maxLength(6000), Validators.required]],
    plans: ["", [Validators.maxLength(6000), Validators.required]],
  });

  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;
  editor1 = new Editor();
  editor2 = new Editor();
  editor3 = new Editor();

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    private readonly toast: ConfirmationToastComponent,
    public readonly accomplishmentService: AccomplishmentService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.form.patchValue({
      success_failure: this.customATOB(this.report().success_failure ?? ""),
      recommendations: this.customATOB(this.report().recommendations ?? ""),
      plans: this.customATOB(this.report().plans ?? ""),
    })
    this.listenForChanges(this.form);
    this.setupAdditionalReports();
    this.formReady = true;
    this.loaded.emit(true);
  }

  setupAdditionalReports() {
    for (let additionalReport of this.report().additional_reports) {
      let form = this.formBuilder.group({
        name: [additionalReport?.name],
        link: [additionalReport?.link, [Validators.pattern(this.reg), Validators.maxLength(500)]],
      })
      this.additional_reports.push({
        form: form,
        additional_report_id: additionalReport.additional_report_id,
      })
      this.listenForChanges(form);
    }
    if (this.additional_reports.length == 0) this.createAdditionalReport();
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save(true);
  }

  route() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 4 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 2 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.reportList()[0].assessment_id, tab: 2 } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  onChangeEditor(html: any, field: any) {
    if (html == '<p></p>') {
      let patch = '{"' + field + '": ""}'
      this.form.patchValue(JSON.parse(patch))
    }
  }

  gatherData(): any {
    let additionalReports = this.additional_reports.map((report:any) => {
      return {additional_report_id: report.additional_report_id, 
        name: report.form.value.name ?? '', 
        link: report.form.value.link ?? ''}
    })
    let data: any = {
      success_failure: this.form.value.success_failure as string | null,
      recommendations: this.form.value.recommendations as string | null,
      plans: this.form.value.plans as string | null,
      additional_reports: additionalReports,
    };
    let allFieldsFilled = true

    for (let field in this.form.controls) {
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        allFieldsFilled = false
      }
    }
    data.allFieldsFilled = allFieldsFilled
    return data
  }

  override save(navigate?: boolean) {
    this.navDebounceCheck(navigate)
    let data = this.gatherData();

    if (!navigate && this.checkIfNotNeedToSave(data)) return

    this.saveSubject.next(null)
    this.status.emit(data.allFieldsFilled ? 2 : 1);
    for(let additionalReport of data.additional_reports) {
      this.updateAdditionalReport(additionalReport);
    }

    //set submitted if submitting report
    let submitted = false;
    let submitted_by: string|undefined;
    let submitted_on: string|undefined;
    if(this.nav() == "forward") {
      submitted = true;
      submitted_by = this.currentUser().full_name;
      let newDateOptions : Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
}
      submitted_on = new Date().toLocaleString("en-US",newDateOptions);
    } 

    this.accomplishmentService.updateAccomplishment({
      accomplishment_id: this.report().accomplishment_id,
      success_failure: data.success_failure,
      recommendations: data.recommendations,
      plans: data.plans,
      page_3_status_id: data.allFieldsFilled ? 2 : 1,
      submitted: submitted,
      submitted_by: submitted_by,
      submitted_on: submitted_on,
    }).subscribe({
      next: (response) => {
        if (navigate) {
          if (this.nav() == "forward" && !data.allFieldsFilled) {
            this.form.markAllAsTouched();
            this.errorList = [];
            for (let field in this.form.controls) {
              const control = this.form.get(field);
              if (control?.invalid) {
                this.errorList.push(field.replaceAll('_', ' '));
              }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.nav.set('');
            this.postSave();
          } else
            this.route(); // navigate route after save because next page needs to see this page's changes
        } else {
          this.postSave();
        }
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
      complete: () => {
        this.form.markAsPristine();
        if (navigate) this.navDebounce = false
      }
    })
  }

  createAdditionalReport() {
    this.accomplishmentService.createAccomplishmentAdditional(this.report().accomplishment_id).subscribe((resp) => {
      let form = this.formBuilder.group({
        name: [''],
        link: ['', [Validators.pattern(this.reg), Validators.maxLength(500)]],
      })
      this.additional_reports.push({
        form: form,
        additional_report_id: resp.additional_report_id,
      })
      this.listenForChanges(form);
    })
  }

  updateAdditionalReport(additionalReport:any) {
    let data = {
      additional_report_id: additionalReport.additional_report_id,
      name: additionalReport.name,
      link: additionalReport.link,
    }
    this.accomplishmentService.updateAccomplishmentAdditional(data).subscribe();
  }

  deleteAdditionalReport(additional_report_id: number) {
    this.accomplishmentService.deleteAccomplishmentAdditional(additional_report_id).subscribe((resp:any) => {
      this.additional_reports.splice(this.additional_reports.findIndex((r: any) => r.additional_report_id === additional_report_id), 1);
    });
  }

  save_close() {
    this.save();
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replace(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.charCodeAt(0) + ';';
    }));
  }
}
